<template>
  <div>
    <nav
      class="navbar navbar-expand-lg navbar-dark fixed-bottom"
      style="background-color: #bf1e2d; height: 1.3em;"
    >
      <div class="container-fluid" style="justify-content:flex-start;">
        <a href="https://www.kablosuzbeyin.com/" target="_blank"
          ><i class="fas fa-brain text-light"></i></a>
        &nbsp; &nbsp;
        <a href="https://www.instagram.com/kablosuzbeyin/" target="_blank"
          ><i class="fab fa-instagram text-light"></i
        ></a>
        &nbsp; &nbsp;
        <a href="https://www.linkedin.com/company/kablosuzbeyin" target="_blank"
          ><i class="fab fa-linkedin text-light"></i
        ></a>
        &nbsp; &nbsp;
        <a href="https://www.twitter.com/kablosuz_beyin" target="_blank"
          ><i class="fab fa-twitter text-light"></i></a>
        &nbsp; &nbsp;
        <a href="https://discord.kablosuzbeyin.com" target="_blank"
          ><i class="fab fa-discord text-light"></i></a>
        &nbsp; &nbsp;
        <a href="https://www.facebook.com/kablosuzbeyin" target="_blank"
          ><i class="fab fa-facebook text-light"></i></a>


      </div>

      <div class="container-fluid justify-content-end">
        <a href="#"><i class="fas fa-arrow-up text-light"></i></a>
      </div>
    </nav>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
